<template>
  <page-view class="page-dashboard mwclg-style">
    <template #pageRight>
      <div v-loading="pageLoading" class="dashboard-inner-wrapper">
        <img
          class="top-bg"
          :src="require('@/assets/images/dashboard/bg.jpg')"
        />
        <div class="period-radio-wrapper">
          <template v-for="(item, pIndex) in periodList">
            <div
              :key="'item-' + item.code"
              :class="{ 'period-item': true, active: periodIndex === pIndex }"
              @click="onDataPeriodChange(item.code, pIndex)"
            >
              {{ item.name }}
            </div>
            <span
              :key="'sep-' + item.code"
              :class="{
                'vertical-sep': true,
                active: pIndex < periodIndex - 1 || pIndex > periodIndex
              }"
            ></span>
          </template>
        </div>
        <div class="data-block-wrapper">
          <h1 class="title">{{ $t('UserInterface.OrderQuantity') }}</h1>
          <div class="data-item-group">
            <div class="data-item">
              <div class="item-label">
                <span class="label-dot"></span
                >{{ $t('UserInterface.CumulativeValue') }}
              </div>
              <div class="item-value-wrapper flex">
                <div class="item-value">{{ periodAccumValue }}</div>
                <div
                  v-if="currPeriod.code != '3'"
                  class="item-change"
                  :class="{
                    asc: periodValChange > 0,
                    desc: periodValChange < 0
                  }"
                >
                  {{
                    new Big(periodValChange * 100).toFixed(2) +
                    ' % ' +
                    currPeriod.prevPeriod +
                    ' '
                  }}
                  <img
                    v-if="periodValChange && Number(periodValChange)"
                    class="icon-change"
                    :src="
                      require(`@/assets/images/dashboard/icon-${
                        periodValChange >= 0 ? 'asc' : 'desc'
                      }.png`)
                    "
                  />
                </div>
              </div>
            </div>
            <!-- <div class="data-item">
              <div class="item-label"><span class="label-dot"></span>本月值</div>
              <div class="item-value">{{ 1238797 }}</div>
            </div> -->
          </div>
        </div>
        <div class="data-barchart-wrapper">
          <h1 class="title">
            {{ $t('UserInterface.OrderQuantityStatistics') }}
          </h1>
          <div ref="dbBarchart" id="dbBarchart"></div>
        </div>
        <div class="disclaimer">
          <div>
            <p>
              &nbsp;<img
                src="@/assets/fms/disclaimerIcon.svg"
                style="display: inline"
              />&nbsp;{{ $t('SeaFreight.Disclaimer') }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </page-view>
</template>

<script>
import { PageView } from '@/components'
import { getDashboardKanBan } from '@/api/dashboard'
import { HttpResponseCode } from '@/utils/request'
import Big from 'big.js'
import i18n from '@/i18n/i18n'
export default {
  components: {
    PageView
  },
  data() {
    this.Big = Big
    return {
      pageLoading: false,
      periodList: [
        {
          name: i18n.t('UserInterface.CurrentMonth'),
          prevPeriod: i18n.t('UserInterface.MonthOnMonth'),
          code: '1',
          dataSource: 'thisMonOrderList',
          accumValue: 'thisMonOrderQuantity',
          changeValue: 'thisMonOrderQuantityMon'
        },
        {
          name: i18n.t('UserInterface.CurrentQuarter'),
          prevPeriod: i18n.t('UserInterface.QuarterOnQuarter'),
          code: '2',
          dataSource: 'thisQuarterOrderList',
          accumValue: 'thisQuarterOrderQuantity',
          changeValue: 'thisQuarterOrderQuantityMon'
        },
        {
          name: i18n.t('UserInterface.CurrentYear'),
          prevPeriod: i18n.t('UserInterface.YearOnYear'),
          code: '3',
          dataSource: 'thisYearOrderList',
          accumValue: 'thisYearOrderQuantity',
          changeValue: ''
        }
      ],
      periodRadio: '1',
      periodIndex: 0,
      barchart: null,
      resData: {
        thisMonOrderList: [],
        thisMonOrderQuantity: 0,
        thisMonOrderQuantityMon: 0,
        thisMonOrderQuantityYoy: 0,
        thisQuarterOrderList: [],
        thisQuarterOrderQuantity: 0,
        thisQuarterOrderQuantityMon: 0,
        thisQuarterOrderQuantityYoy: 0,
        thisYearOrderList: [],
        thisYearOrderQuantity: 0,
        thisYearOrderQuantityYoy: 0
      },
      lang: 'zh',
    }
  },
  computed: {
    currPeriod() {
      return this.periodList[this.periodIndex]
    },
    periodAccumValue() {
      return this.resData[this.currPeriod.accumValue] || 0
    },
    periodValChange() {
      if (this.currPeriod.changeValue) {
        return this.resData[this.currPeriod.changeValue] || 0
      }
      return 0
    }
  },
  async mounted() {
    this.pageLoading = true
    await getDashboardKanBan().then(res => {
      if (res && res.code === HttpResponseCode.SUCCESS) {
        const result = JSON.parse(res.data || '{}')
        this.resData = {
          ...this.resData,
          ...result
        }
      }
    })
    this.pageLoading = false
    this.lang = this.$ls.get('lang');
    this.barchartInit()
    const _this = this
    window.onresize = function () {
      _this.barchart.resize()
    }
  },
  methods: {
    onDataPeriodChange(periodCode, pIndex) {
      this.periodRadio = periodCode
      this.periodIndex = pIndex
      this.setBarchart(this.currPeriod.dataSource)
    },
    barchartInit() {
      this.barchart = this.$echarts.init(document.getElementById('dbBarchart'))
      this.setBarchart(this.currPeriod.dataSource)
    },
    setBarchart(source) {
      const _this = this
      const labelList = this.resData[source].map(item => {
        return this.lang == 'zh' ? item.maincategName : item.maincategNameEn
      })
      const dataList = this.resData[source].map(item => {
        return Number(item.orderNum)
      })
      const UPPER_SPACE = 0
      const maxVal = Math.max(...dataList)
      const topVal = maxVal * (1 + UPPER_SPACE)
      const upperDataList = dataList.map(item => topVal - item)

      // console.log(this.barchart, this.resData, labelList, dataList)
      const newOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            return `${params[0].marker} ${params[0].name} ${params[0].value}`
          }
        },
        xAxis: {
          data: labelList,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'lightgray'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: 'gray',
            padding: [8, 0, 0, 0]
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: 'dashed'
            }
          }
        },
        // 栅格
        // grid: {
        //   left: '0',
        //   right: '0',
        //   bottom: '0%',
        //   top: '22px',
        //   containLabel: true
        // },
        grid: {
          left: '5%',
          top: '10%',
          right: '0%',
          bottom: '10%'
        },
        series: [
          // 数据低下的圆片
          {
            name: '',
            type: 'pictorialBar',
            symbol: 'diamond',
            symbolSize: [32, 18], // 宽，高
            symbolOffset: [0, 9], // 左 上
            symbolPosition: 'start',
            z: 1,
            data: dataList,
            itemStyle: {
              color: (params) => {
                return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#69C3FF' },
                  { offset: 1, color: '#85F3F9' }
                ])
              }
            }
          },
          // 数据的柱状图
          {
            name: '',
            type: 'bar',
            barWidth: 16, // 柱条的宽度，不设时自适应。
            data: dataList,
            stack: 'one',
            itemStyle: {
              color: (params) => {
                return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#69C3FF' },
                  { offset: 1, color: '#85F3F9' }
                ])
              }
              // emphasis: {
              //   borderWidth: 15,
              //   borderColor: 'red',
              // }
            }
          },
          {
            name: '',
            type: 'bar',
            barWidth: 16, // 柱条的宽度，不设时自适应。
            barGap: 0, // 不同系列的柱间距离
            data: dataList,
            stack: 'two',
            itemStyle: {
              normal: {
                color: (params) => {
                  return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#69C3FF' },
                    { offset: 1, color: '#85F3F9' }
                  ])
                },
                borderWidth: 0.1,
                borderColor: 'transparent'
              }
            }
          },
          // 数据顶部的样式
          {
            name: '',
            type: 'pictorialBar',
            symbol: 'diamond',
            symbolSize: [32, 18],
            symbolOffset: [0, -9],
            symbolPosition: 'end',
            data: dataList,
            z: 4,
            itemStyle: {
              normal: {
                color: (params) => {
                  return new _this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    { offset: 0, color: '#69C3FF' },
                    { offset: 1, color: '#85F3F9' }
                  ])
                },
                label: {
                  show: false, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: {
                    fontSize: '12',
                    color: '#B0E1FF'
                  }
                }
              }
            }
          },
          // 数据上部的半透柱状图
          {
            name: '',
            type: 'bar',
            barWidth: 16, // 柱条的宽度，不设时自适应。
            data: upperDataList,
            stack: 'one',
            itemStyle: {
              color: (params) => {
                return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#E9F7FF' },
                  { offset: 1, color: '#EDFDFF' }
                ])
              }
              // emphasis: {
              //   borderWidth: 15,
              //   borderColor: 'red',
              // }
            },
            emphasis: {
              disabled: true
            }
          },
          {
            name: '',
            type: 'bar',
            barWidth: 16, // 柱条的宽度，不设时自适应。
            barGap: 0, // 不同系列的柱间距离
            data: upperDataList,
            stack: 'two',
            itemStyle: {
              normal: {
                color: (params) => {
                  return new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#E9F7FF' },
                    { offset: 1, color: '#EDFDFF' }
                  ])
                },
                borderWidth: 0.1,
                borderColor: 'transparent'
              }
            },
            emphasis: {
              disabled: true
            }
          },
          {
            name: '',
            type: 'pictorialBar',
            symbol: 'diamond',
            symbolSize: [32, 18],
            symbolOffset: [0, -9],
            symbolPosition: 'end',
            data: Array(upperDataList.length).fill(topVal),
            stack: 'one',
            z: 3,
            itemStyle: {
              normal: {
                color: (params) => {
                  return new _this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                    { offset: 0, color: '#DBF5FF' },
                    { offset: 1, color: '#E9F7FF' }
                  ])
                },
                label: {
                  show: false, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: {
                    fontSize: '12',
                    color: '#B0E1FF'
                  }
                }
              }
            },
            emphasis: {
              disabled: true
            }
          }
        ]
      }
      this.barchart.setOption(newOption)
      // this.barchart.setOption({
      //   tooltip: {
      //     trigger: 'axis',
      //     axisPointer: {
      //       type: 'shadow'
      //     }
      //   },
      //   xAxis: {
      //     data: labelList,
      //     axisLine: {
      //       show: false
      //     },
      //     axisTick: {
      //       show: false
      //     },
      //     axisLabel: {
      //       interval: 0
      //     }
      //   },
      //   yAxis: {
      //     type: 'value',
      //     splitLine: {
      //       show: true,
      //       lineStyle: {
      //         width: 1,
      //         type: 'dashed'
      //       }
      //     }
      //   },
      //   dataZoom: {
      //     show: true,
      //     start: 0,
      //     type: 'inside',
      //     // end: (5 / labelList) * 100,
      //     zoomLock: true
      //   },
      //   series: [{
      //     type: 'bar',
      //     barWidth: '20%',
      //     barMaxWidth: '30',
      //     data: dataList,
      //     itemStyle: {
      //       color: 'blue',
      //       barBorderRadius: [5, 5, 0, 0]
      //     }
      //   }],
      //   grid: {
      //     left: '2%',
      //     top: '10%',
      //     right: '0%',
      //     bottom: '10%'
      //   }
      // })
    }
  }
}
</script>

<style lang="less">
.page-dashboard {
  background-color: #f0f6fb;
  min-height: 90vh;
  .dashboard-inner-wrapper {
    position: relative;
    padding-top: 26px;
    // background-image: url('../../assets/images/dashboard/bg.jpg');
    // background-repeat: no-repeat;
    // background-size: contain;
    // background-position: top center;
    min-height: 60vh;
    .top-bg {
      position: absolute;
      width: 100%;
      top: 0;
      object-fit: cover;
      // z-index: ;
    }
    .period-radio-wrapper {
      // margin: 24px 0 24px 30px;
      position: relative;
      display: flex;
      align-items: center;
      width: fit-content;
      margin-left: 30px;
      margin-bottom: 20px;
      padding: 4px;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(2px);
      .period-item {
        color: #4b5563;
        font-size: 14px;
        line-height: 16px;
        padding: 4px 12px;
        cursor: pointer;
        // &::after {
        //   content: "";
        //   display: inline-block;
        //   height: 14px;
        //   width: 1px;
        //   margin-bottom: -2px;
        //   margin-left: 6px;
        //   background-color: lightgray;
        // }
        &.active {
          color: #59b9d3;
          background-color: white;
          border-radius: 6px;
          border-right: 0;
          // &::after {
          //   display: none;
          // }
        }
        &:last-child {
          // &::after {
          //   display: none;
          // }
        }
      }
      .vertical-sep {
        display: inline-block;
        height: 14px;
        width: 1px;
        margin-bottom: -2px;
        background-color: transparent;
        &.active:not(:last-child) {
          background-color: lightgray;
        }
      }
    }
    .data-block-wrapper {
      position: relative;
      margin: 0 10px;
      margin-bottom: 10px;
      padding: 16px 20px;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(2px);
      border-radius: 4px;
      .title {
        color: #111827;
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      .data-item-group {
        display: flex;
        // .data-item {
        //   margin-right: 200px;
        // }
        gap: 200px;
      }
      .item-label {
        display: flex;
        align-items: center;
        color: #9ca3af;
        font-size: 12px;
        line-height: 17px;
        .label-dot {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          text-align: center;
          border: 1px solid #5998d3;
          background: #ffffff;
          margin-right: 4px;
        }
      }
      .item-value-wrapper {
        align-items: baseline;
        .item-value {
          color: #4b5563;
          font-weight: 600;
          font-size: 18px;
          line-height: 25px;
        }
        .item-change {
          margin-left: 12px;
          font-size: 12px;
          display: flex;
          align-items: center;
          &.asc {
            color: #f87171;
          }
          &.desc {
            color: #35c29f;
          }
          .icon-change {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }
    }
    .data-barchart-wrapper {
      position: relative;
      margin: 0 10px;
      // margin-bottom: 10px;
      margin-bottom: 36px;
      padding: 16px 20px;
      background-color: #ffffff;
      border-radius: 4px;
      .title {
        color: #111827;
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      #dbBarchart {
        width: 100%;
        height: 300px;
      }
    }
    .disclaimer {
      position: fixed;
      left: 210px;
      bottom: 0;
      right: 0;
      background: #f0f6fc;
      color: #8ca2bd;
      opacity: 0.85;
      font-size: 12px;
      height: 36px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      z-index: 3;
    }
  }
}
</style>
